import React, { JSX } from 'react';

// Types
import { IMlCardProps } from './ml-card.types';

// Utils
import { MlCardBase } from './ml-card-base';
import { MlCardClient } from './ml-card.client';

/**
 * MlCard is a highly flexible, multi-variant card component used across the site.
 * It supports icons, images, CTAs, home plan layouts, stat selections, and more.
 *
 * The card dynamically determines what to render based on its variant prop.
 *
 */
export const MlCard = (props: IMlCardProps): JSX.Element => {
  const { onClick, onFocus } = props;
  const hasClientInteractivity = !!onClick || !!onFocus;

  if (!hasClientInteractivity) {
    return <MlCardBase {...props} />;
  } else {
    return <MlCardClient {...props} />;
  }
};
